export default __webpack_public_path__ + "static/media/WellBeingProject8.30ca4122.png";